const LOGIN_STEP = {
  AUTH: "auth",
  MFA: "mfa",
  NEW_PASSWORD: "new_password",
};

export default LOGIN_STEP;
